import { render, staticRenderFns } from "./ListOtherERC.vue?vue&type=template&id=1ab2436c&"
import script from "./ListOtherERC.vue?vue&type=script&lang=js&"
export * from "./ListOtherERC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports